module.exports = __webpack_public_path__ + "static/media/earth-planet.1cde7700.png";